var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{style:(_vm.iframe.style),attrs:{"src":_vm.iframe.src,"height":_vm.iframe.style.height,"width":_vm.iframe.style.width,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }